module.exports = __webpack_public_path__ + "img/searchXIcon.531b7ab5.svg";